import { render, staticRenderFns } from "./HotspotItem.vue?vue&type=template&id=51f844a4"
import script from "./HotspotItem.vue?vue&type=script&lang=js"
export * from "./HotspotItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports